import chargebee from "../assets/Projects/1.png";
import netmeds from "../assets/Projects/2.png";
import optimizley from "../assets/Projects/3.png";

export const allProjects = [
  {
    title: "Chargebee (Clone)",
    image: chargebee,
    techStack:
      "React|Redux|Swiperjs|Chakra ui|Axios|JsonServer|Html|Css|Firebase|FireBaseAuth ",
    about:
      "Charege bee is subscription managemnt website and we try to clone this website, this collaborative Project",
    areaofResponsiblity:
      "Landing page and navbar hover card and responsiveness",
    github: "https://github.com/Sunilkumar93/fluffy-shelf-1478",
    deployed: "https://fluffy-shelf-1478.vercel.app/",
  },
  {
    title: "Netmeds (Clone)",
    image: netmeds,
    techStack: "React|chakra|jsonServer|axios|js|html|css",
    about:
      "netmeds is online website where you can buy online medicine this individual Project",
    areaofResponsiblity: "all",
    github: "https://github.com/Sunilkumar93/stark-business-7502",
    deployed: "https://stark-business-7502.vercel.app/",
  },
  {
    title: "Optimizly (Clone)",
    image: optimizley,
    techStack: "Html Css js import export using module",
    about:
      "A website that provides digital experience platform software as a service. this collaborative Project",
    areaofResponsiblity: "landing page|navbar|footer",
    github: "https://github.com/Sunilkumar93/optimizely.com-clone",
    deployed: "https://funny-kataifi-02e4e4.netlify.app/index.html",
  },
  {
    title: "Chargebee (Clone)",
    image: chargebee,
    techStack:
      "React|Redux|Swiperjs|Chakra ui|Axios|JsonServer|Html|Css|Firebase|FireBaseAuth ",
    about:
      "Charege bee is subscription managemnt website and we try to clone this website, this collaborative Project",
    areaofResponsiblity:
      "Landing page and navbar hover card and responsiveness",
    github: "https://github.com/Sunilkumar93/fluffy-shelf-1478",
    deployed: "https://fluffy-shelf-1478.vercel.app/",
  },
];
